import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorCustomerSalesSearch = () => {
  const customerSalesSearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/customer/sales/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])
  return { customerSalesSearch }
}

export default InteractorCustomerSalesSearch
